import React from "react";
import { useNavigate } from "react-router-dom";
import Banner from "../components/Banner";

const WelcomePage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  const handleRegistroRedirect = () => {
    navigate("/registro");
  };

  return (
    <div className="container">
      <Banner />
      <h1 className="title">Welcome Page</h1>
      <div className="container2">
      <button onClick={handleLoginRedirect}  className="button">Iniciar Sesión</button>
      <p></p>
      <button onClick={handleRegistroRedirect}  className="button">Registro Nuevo</button>
      </div>
    </div>
  );
};

export default WelcomePage;